module.exports = __webpack_public_path__ + "img/banner_right1.a8bc3bdf.png";